import { Component, ViewEncapsulation } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { RelatedJobBus } from '@app/cp/shared/models/RelatedJobBus';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { aggregateBy } from '@progress/kendo-data-query';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
@Component({
    selector: 'contract-jobs',
    templateUrl: './contract-jobs.component.html',
    styleUrls: ['./contract-jobs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContractJobsComponent extends BaseGridUIComponent<RelatedJobBus, null, ConstructionService>  {

    constructor(svc_data: ConstructionService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;
        this.aggregates = [
              { field: 'totalLaborCosts', aggregate: 'sum' }
            , { field: 'totalMatCosts', aggregate: 'sum' }
            , { field: 'totalOtherCosts', aggregate: 'sum' }
            , { field: 'totalCosts', aggregate: 'sum' }
            , { field: 'totalQuote', aggregate: 'sum' }
            , { field: 'totalQuoteCost', aggregate: 'sum' }
        ];
    }
    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
        }
    }
}
